import styled from '@emotion/styled';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useWebhookComponentContext } from '../../contex';
import { WebhookFormValues } from '../../types';
import { ConfigureTabFooter } from './ConfigureTabFooter';
import { FormContent } from './FormContent';
import { JsonContent } from './JsonContent';

const ConfigureTabContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 24px;
    margin-top: 24px;
    flex: 1;
`;

export const ConfigureTabContent = () => {
    const { setActiveTab, mode, webhookIndex, onWebhookRemove } = useWebhookComponentContext();
    const { formState, trigger } = useFormContext<WebhookFormValues>();
    const [view, setView] = useState<'form' | 'json'>('form');

    const { isValid } = formState;

    return (
        <ConfigureTabContentContainer>
            {view === 'form' && <FormContent mode={mode} />}
            {view === 'json' && <JsonContent mode={mode} />}
            <ConfigureTabFooter
                view={view}
                onViewChange={setView}
                onContinue={isValid ? () => setActiveTab('test') : () => trigger()}
                onDelete={webhookIndex !== null ? onWebhookRemove : undefined}
            />
        </ConfigureTabContentContainer>
    );
};
